/** 网络请求 */
import * as log from './log';

/** 基础方法库*/
import * as bll from './bll';

/** 基础类库 */
import * as lib from './lib.js';

/** 基础json */
import * as json from './json';

/** 基础html */
import * as html from './html';

/** xml 处理方法 */
import * as xml from './xml';

/** 数据缓存 */
import * as storage from './storage';
import * as cookie from './cookie';

/** 缓存对象 */
import Cache from './cache';
import Subscribe from './subscribe';

import { View } from './view';

/**
 * 全局原生参数扩展方法
 */
import { initString, initDate, initNumber } from './init';

/** 全局原生参数扩展初始化 */
const init = () => {
  initString();
  initDate();
  initNumber();
};

export {
  bll,
  lib,
  json,
  html,
  xml,
  log,
  Cache,
  Subscribe,
  cookie,
  initString,
  initDate,
  initNumber,
  init,
  storage,
  View
};
